import React, {useContext} from 'react';
import {useIntl} from 'react-intl';

import './index.style.less';
import {Button} from 'antd';
import {AppstoreOutlined, UnorderedListOutlined} from '@ant-design/icons';
import {BiImageAdd} from 'react-icons/all';
import clsx from 'clsx';
import {MediaContext} from '../MediaContext';

const MediaHeader = () => {
  const intl = useIntl();

  const mediaContext = useContext(MediaContext);
  const {
    mediaList,
    readOnly,
    viewType,
    setViewType,
    setSelectedMediaId,
    setEditing,
  } = mediaContext;

  const onAdd = () => {
    setSelectedMediaId(null);
    setEditing(true);
  };

  const onChangeView = (type) => {
    setViewType(type);
  };

  return (
    <div className='product-header'>
      <div className='product-header-left'>
        <h3>{intl.messages['media.list']}</h3>
        <span className='product-header-showing-text text-truncate'>
          ({mediaList?.length} item)
        </span>
      </div>
      <div className='product-header-right'>
        {!readOnly && (
          <Button className='product-header-btn' onClick={() => onAdd()}>
            <BiImageAdd />
          </Button>
        )}
        <Button
          className={clsx('product-header-btn', {
            active: viewType === 'LIST',
          })}
          onClick={() => onChangeView('LIST')}>
          <UnorderedListOutlined />
        </Button>
        <Button
          className={clsx('product-header-btn', {
            active: viewType === 'GRID',
          })}
          onClick={() => onChangeView('GRID')}>
          <AppstoreOutlined />
        </Button>
      </div>
    </div>
  );
};

export default MediaHeader;
